import React from "react"
import { FormattedMessage, } from "react-intl"
import { StockDocumentTimelineProps } from "../../../common/types/timeline"

const StockDocumentCreatedComponent = (props: StockDocumentTimelineProps) => {

    return <div className={"row"}>
        <div 
            className="col-12" 
            data-document-event="stock-document-created"
            data-document-direction={props.stockDocument.attributes.definition.attributes.direction.toLowerCase()} >
            <FormattedMessage
                id="quote.events.stock_document_sent.text"
                defaultMessage="{document} {identifier} has been created"
                values={{
                    document: props.stockDocument.attributes.definition.attributes.name,
                    identifier: props.stockDocument.attributes.identifier
                }}
            />
        </div>
    </div>
}

export default StockDocumentCreatedComponent








// WEBPACK FOOTER //
// ./src/quote/analytics/events/stock-document-created.component.tsx